import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import {  Mail, Users, Home as HomeIcon, ShoppingBag, Heart, Shield} from 'lucide-react';

import Header from '../components/header';
import Hero from '../components/hero';
import Products from '../components/products';
import Quality from '../components/quality';
import Contact from '../components/contact';
import Footer from '../components/footer';
import About from "../components/about";
import SociosComerciales from "../components/sociosComerciales";
import CareersSection from "../components/joinTeam";
import Timeline from "../components/linetime";
import Chatbox from "../components/chatbox";
import Introducción from "../components/introducción";
import RecetarioGourmet from "../components/recetario";
import FacilitiesSection from "../components/estructura"; 


const navigationItems = [
  { id: 'inicio', name: '', icon: HomeIcon },
  { 
    id: 'productos', 
    name: 'Nuestros Productos',
    icon: ShoppingBag,
    // subItems: [
    //   { id: 'recetario', name: 'Recetario' }
    // ]
  },
  { id: 'instalaciones', name: 'Nuestras Instalaciones', icon: Shield },
  { id: 'clientes', name: 'Socios Comerciales', icon: Users },
  // { id: 'socios', name: 'Socios de Negocios', icon: ShoppingBag },
  { id: 'trabajo', name: 'Únete al equipo', icon: Heart },
  { id: 'contacto', name: 'Contacto', icon: Mail },
  { id: 'politica', name: 'Políticas', icon: Shield },
];

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState('inicio');

  // Determinar la vista actual basada en la ruta
  useEffect(() => {
    const path = location.pathname;
    let view = 'inicio';
    
    if (path === '/' || path === '/inicio') {
      view = 'inicio';
    } else if (path === '/productos') {
      view = 'productos';
    } else if (path === '/socios') {
      view = 'socios';
    } else if (path === '/trabajo') {
      view = 'trabajo';
    } else if (path === '/clientes') {
      view = 'clientes';
    } else if (path === '/trabajo') {
      view = 'trabajo';
    } else if (path === '/contacto') {
      view = 'contacto';
    } else if (path === '/politica') {
      view = 'politica';
    } else if (path === '/recetario') {
        view = 'recetario';
    } else if (path === '/instalaciones') {
      view = 'instalaciones';
    }
    
    setCurrentView(view);
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const scrollToSection = (id) => {
    // Navegar a la nueva ruta
    if (id === 'inicio') {
      navigate('/');
    } else {
      navigate(`/${id}`);
    }
  };

  const renderContent = () => {
    switch(currentView) {      case 'inicio':
        return (
          <>
            <Hero currentView={currentView} setCurrentView={setCurrentView} />
            <Introducción />
            <Quality />

          </>
        );
      case 'productos':
        return <Products />;
        case 'instalaciones':
        return <FacilitiesSection />;
      case 'contacto':
        return <Contact />;
        case 'clientes':  
        return <SociosComerciales />;
        case 'trabajo':
          return <CareersSection />;
          // case 'noticias':
          //   return <NewsComponent />;
            case 'politica':
              return ( 
              <>
              <About />
              <Timeline />
              </> 
              )
              // case 'recetario':
              //   return <RecetarioGourmet />;
      default:
    }
  };  return (
    <div className="min-h-screen flex flex-col">
      <Header 
        navigationItems={navigationItems}
        activeSection={currentView}
        scrollToSection={scrollToSection}
      />
      <main className="pt-20 flex-grow">
        {renderContent()}
      </main>
      <Footer currentView={currentView} setCurrentView={setCurrentView} />
      <Chatbox />
    </div>
  );
};

export default Home;